import { render, staticRenderFns } from "./CropmarketalaysisForMonth.vue?vue&type=template&id=22c4bb9e&"
import script from "./CropmarketalaysisForMonth.vue?vue&type=script&lang=js&"
export * from "./CropmarketalaysisForMonth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports